/**
 * Accessible menu accordion for column menus.
 * Desktop: always expanded (toggle is presentational).
 * Mobile: first accordion open by default; others collapsed.
 * Without JS, lists stay visible (aria-expanded defaults to true).
 */
(() => {
  const TAG = 'menu-accordion';
  const DESKTOP_QUERY = '(min-width: 768px)';

  class MenuAccordion extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.menu__toggle');
      this.list = this.querySelector('.menu__list');

      if (!this.toggle || !this.list) return;

      this.mediaQuery = window.matchMedia(DESKTOP_QUERY);
      this.onClick = this.onClick.bind(this);
      this.syncForViewport = this.syncForViewport.bind(this);

      this.toggle.addEventListener('click', this.onClick);
      this.mediaQuery.addEventListener('change', this.syncForViewport);
      this.syncForViewport();
    }

    disconnectedCallback() {
      if (this.toggle) {
        this.toggle.removeEventListener('click', this.onClick);
      }

      if (this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.syncForViewport);
      }
    }

    setExpanded(expanded) {
      this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    syncForViewport() {
      if (this.mediaQuery.matches) {
        this.setExpanded(true);
        this.toggle.setAttribute('tabindex', '-1');
        return;
      }

      this.toggle.removeAttribute('tabindex');

      if (!this.dataset.userToggled) {
        const root =
          this.closest('.site-footer__main') ||
          this.closest('section') ||
          document;
        const first = root.querySelector(TAG);
        this.setExpanded(first === this);
      }
    }

    onClick(event) {
      if (this.mediaQuery.matches) {
        event.preventDefault();
        return;
      }

      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.setExpanded(!expanded);
      this.dataset.userToggled = 'true';
    }
  }

  if (!customElements.get(TAG)) {
    customElements.define(TAG, MenuAccordion);
  }
})();
